// Define the FilterBalanceType enum
export enum FilterBalanceType {
  GENERAL = 'GENERAL',
  IMMO = 'IMMO',
  CLIENTS = 'CLIENTS',
  FOURNISSEURS = 'FOURNISSEURS',
  BANQUE = 'BANQUE',
  EXPLOITATIONS = 'EXPLOITATIONS',

  COMPTES_NON_SOLDES_N = 'COMPTES_NON_SOLDES_N',
  COMPTES_NON_VUS_N = 'COMPTES_NON_VUS_N',
  COMPTES_MOUVEMENTES_N = 'COMPTES_MOUVEMENTES_N',
  COMPTES_A_REVOIR_N = 'COMPTES_A_REVOIR_N',
  COMPTES_SOLDES_ET_NON_LETTRES_N = 'COMPTES_SOLDES_ET_NON_LETTRES_N',

  COMPTES_NON_SOLDES_N_OU_N_1 = 'COMPTES_NON_SOLDES_N_OU_N_1',
  COMPTES_NON_VUS_N_OU_N_1 = 'COMPTES_NON_VUS_N_OU_N_1',
  COMPTES_MOUVEMENTES_N_OU_N_1 = 'COMPTES_MOUVEMENTES_N_OU_N_1',
  COMPTES_A_REVOIR_N_OU_N_1 = 'COMPTES_A_REVOIR_N_OU_N_1',
  COMPTES_SOLDES_ET_NON_LETTRES_N_OU_N_1 = 'COMPTES_SOLDES_ET_NON_LETTRES_N_OU_N_1',

  TOUS_LES_COMPTES_CREES = 'TOUS_LES_COMPTES_CREES',
  TOUS_LES_COMPTES = 'TOUS_LES_COMPTES',
  COMPTABILITE_STANDARD = 'COMPTABILITE_STANDARD',
  COMPTABILITE_ANALYTIQUE = 'COMPTABILITE_ANALYTIQUE',
}
/**
 * @constant {FilterBalanceType[]} advancedFilters - Liste des filtres analytiques avancés pour la balance.
 */
export const advancedFilters: FilterBalanceType[] = [
  FilterBalanceType.COMPTES_NON_SOLDES_N,
  FilterBalanceType.COMPTES_NON_VUS_N,
  FilterBalanceType.COMPTES_MOUVEMENTES_N,
  FilterBalanceType.COMPTES_A_REVOIR_N,
  FilterBalanceType.COMPTES_SOLDES_ET_NON_LETTRES_N,
  FilterBalanceType.COMPTES_NON_SOLDES_N_OU_N_1,
  FilterBalanceType.COMPTES_NON_VUS_N_OU_N_1,
  FilterBalanceType.COMPTES_MOUVEMENTES_N_OU_N_1,
  FilterBalanceType.COMPTES_A_REVOIR_N_OU_N_1,
  FilterBalanceType.COMPTES_SOLDES_ET_NON_LETTRES_N_OU_N_1,
  FilterBalanceType.TOUS_LES_COMPTES_CREES,
  FilterBalanceType.TOUS_LES_COMPTES,
];
/**
 * @constant {FilterBalanceType[]} basicFilters - Liste des types de filtres basiques disponibles.
 */
export const basicFilters: FilterBalanceType[] = [
  FilterBalanceType.GENERAL,
  FilterBalanceType.IMMO,
  FilterBalanceType.CLIENTS,
  FilterBalanceType.FOURNISSEURS,
  FilterBalanceType.BANQUE,
  FilterBalanceType.EXPLOITATIONS,
];
